module.exports = __webpack_public_path__ + "img/project-classroom-3.fd8ce08d.png";